import { createSender } from '../../../../channel';
export const add = createSender('uiModulePaymentOverviewCard');
//# sourceMappingURL=index.js.map